import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { utils } from '@atlaskit/util-service-support';
/**
 * Utility class to retrieve/modify all actions on reactions collection
 */
export var ReactionServiceClient = /*#__PURE__*/function () {
  /**
   * oAuth token
   */

  /**
   * API config
   */

  /**
   *
   * @param baseUrl base domain url
   * @param sessionToken oAuth token for reactions emoji services
   */
  function ReactionServiceClient(baseUrl, sessionToken) {
    var _this = this;
    _classCallCheck(this, ReactionServiceClient);
    /**
     * Send a request to remote service
     * @param path endpoint api url
     * @param options Optional custom params
     */
    _defineProperty(this, "requestService", function (path, options) {
      return utils.requestService(_this.serviceConfig, _objectSpread(_objectSpread({}, options), {}, {
        path: path
      }));
    });
    this.serviceConfig = {
      url: baseUrl
    };
    this.sessionToken = sessionToken;
  }

  /**
   * Get http headers for the "fetch" request
   * @param hasBody
   */
  _createClass(ReactionServiceClient, [{
    key: "getHeaders",
    value: function getHeaders() {
      var headers = {};
      headers['Accept'] = 'application/json';
      headers['Content-Type'] = 'application/json';
      if (this.sessionToken) {
        headers['Authorization'] = this.sessionToken;
      }
      return headers;
    }
  }, {
    key: "getReactions",
    value: function getReactions(containerAri, aris) {
      if (aris.length === 0) {
        return Promise.resolve({});
      }
      return this.requestService('reactions/view', {
        requestInit: {
          method: 'POST',
          headers: this.getHeaders(),
          body: JSON.stringify({
            containerAri: containerAri,
            aris: aris
          })
        }
      });
    }
  }, {
    key: "getDetailedReaction",
    value: function getDetailedReaction(containerAri, ari, emojiId) {
      var reactionId = "".concat(containerAri, "|").concat(ari, "|").concat(emojiId);
      var headers = this.getHeaders();
      return this.requestService('reactions', {
        queryParams: {
          reactionId: reactionId
        },
        requestInit: {
          headers: headers,
          method: 'GET',
          credentials: 'include'
        }
      });
    }
  }, {
    key: "addReaction",
    value: function addReaction(containerAri, ari, emojiId, metadata) {
      return this.requestService('reactions', {
        requestInit: {
          method: 'POST',
          headers: this.getHeaders(),
          body: JSON.stringify(_objectSpread({
            emojiId: emojiId,
            ari: ari,
            containerAri: containerAri
          }, metadata ? {
            metadata: JSON.stringify(metadata)
          } : {})),
          credentials: 'include'
        }
      }).then(function (_ref) {
        var reactions = _ref.reactions;
        return reactions;
      });
    }
  }, {
    key: "deleteReaction",
    value: function deleteReaction(containerAri, ari, emojiId, metadata) {
      return this.requestService('reactions', {
        queryParams: _objectSpread({
          ari: ari,
          emojiId: emojiId,
          containerAri: containerAri
        }, metadata ? {
          metadata: JSON.stringify(metadata)
        } : {}),
        requestInit: {
          method: 'DELETE',
          headers: this.getHeaders(),
          credentials: 'include'
        }
      }).then(function (_ref2) {
        var reactions = _ref2.reactions;
        return reactions;
      });
    }
  }]);
  return ReactionServiceClient;
}();